<template>
    <div class="add-work-container container" style="margin-top: 70px;">
      <Header pageTitle="اضافة عمل" />
      <p style="font-weight: bold; color: #296080; font-size: large;">إضافة عمل جديد</p>
      <form @submit.prevent="saveWork">
        <div class="form-group">
          <label style="color: #296080;" for="workTitle">عنوان العمل</label>
          <input type="text" id="workTitle" v-model="work.title" required>
        </div>
        <div class="form-group">
          <label style="color: #296080;" for="workContent">وصف العمل</label>
          <input type="text" id="workContent" v-model="work.content" required>
        </div>
        <div class="form-group">
          <label for="workImage">إضافة صورة (اختياري)</label>
          <input type="file" id="workImage" ref="fileInput" @change="handleImageUpload">
        </div>
        <button type="submit" style="width: 100%; margin-bottom: 50px; border-radius: 10px;" class="btn btn-primary">
          حفظ العمل
        </button>
      </form>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import Header from "../../components/header.vue";
  
  export default {
    components: {
      Header,
    },
    data() {
      return {
        work: {
          title: "",
          content: "",
          image: null,
        },
      };
    },
    methods: {
      handleImageUpload(event) {
        this.work.image = event.target.files[0];
      },
      async saveWork() {
        // استرجاع معرف المستخدم من localStorage
        const userId = localStorage.getItem("userId");
        if (!userId) {
          console.error("معرف المستخدم غير موجود في localStorage.");
          return;
        }
  
        const formData = new FormData();
        formData.append("title", this.work.title);
        formData.append("content", this.work.content);
        formData.append("usersid", userId);
        if (this.work.image) {
          formData.append("image", this.work.image);
        }
  
        try {
          const response = await axios.post(
            "https://zadcodeonline.com/ahmad/etqan/backEnd/portfolio/add_portfolio.php",
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          console.log("تم إضافة العمل بنجاح:", response.data);
          this.$router.push({ name: 'MyWorks' });
          // يمكنك عرض رسالة نجاح أو إعادة التوجيه حسب الحاجة
          this.resetForm();
        } catch (error) {
          console.error("حدث خطأ أثناء إضافة العمل:", error);
          // يمكنك عرض رسالة خطأ للمستخدم هنا
        }
      },
      resetForm() {
        this.work.title = "";
        this.work.content = "";
        this.work.image = null;
        // إعادة تعيين قيمة حقل الصورة
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .add-work-container {
    direction: rtl;
    text-align: right;
    padding: 40px 30px 0px 30px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  label {
    display: block;
    margin-bottom: 5px;
  }
  
  input,
  select {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  button {
    padding: 10px 20px;
    background-color: #296080;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  button:hover {
    background-color: #1d4a60;
  }
  </style>
  